




import { Component, Mixins } from "vue-property-decorator";
import { FormatReference } from "../../../domain/format";
import PreviewedFormatSelectorDialog from "../../format/dialogs/PreviewedFormatSelectorDialog.vue";

@Component({
  components: {
    selector: PreviewedFormatSelectorDialog,
  },
})
export default class ExtraFormatSelectorDialog extends Mixins() {
  async show(items: FormatReference[], selectedItem: FormatReference = null): Promise<FormatReference> {
    const selector = this.$refs.selector as PreviewedFormatSelectorDialog;
    return selector.show(items, selectedItem);
  }
}
